// Polish phrases

export default {
  com_ui_examples: 'Przykłady',
  com_ui_new_chat: 'Nowy czat',
  com_ui_happy_birthday: 'To moje pierwsze urodziny!',
  com_ui_example_quantum_computing: 'Wyjaśnij obliczenia kwantowe w prostych słowach',
  com_ui_example_10_year_old_b_day: 'Masz jakieś kreatywne pomysły na dziesiąte urodziny?',
  com_ui_example_http_in_js: 'Jak wykonać żądanie HTTP w JavaScript?',
  com_ui_capabilities: 'Możliwości',
  com_ui_capability_remember: 'Pamięta to, co użytkownik powiedział wcześniej w rozmowie',
  com_ui_capability_correction: 'Pozwala użytkownikowi wprowadzać poprawki do dalszej rozmowy',
  com_ui_capability_decline_requests: 'Szkolony do odrzucania nieodpowiednich żądań',
  com_ui_limitations: 'Ograniczenia',
  com_ui_limitation_incorrect_info: 'Czasami może podać nieprawidłowe informacje',
  com_ui_limitation_harmful_biased:
    'Czasami może generować szkodliwe instrukcje lub stronniczą treść',
  com_ui_limitation_limited_2021: 'Ograniczona świadomość świata i wydarzeń po roku 2021',
  com_u_input: 'Wejście',
  com_u_close: 'Zamknij',
  com_u_model: 'Model',
  com_ui_select_model: 'Wybierz model',
  com_ui_use_prompt: 'Użyj podpowiedzi',
  com_ui_prev: 'Poprzedni',
  com_ui_next: 'Następny',
  com_ui_prompt_templates: 'Szablony podpowiedzi',
  com_ui_hide_prompt_templates: 'Ukryj szablony podpowiedzi',
  com_ui_showing: 'Pokazuje',
  com_ui_of: 'z',
  com_ui_entries: 'wpisów',
  com_ui_pay_per_call:
    'Wszystkie rozmowy z AI w jednym miejscu. Płatność za połączenie, a nie za miesiąc',
  com_ui_share: 'Udostępnij',
  com_ui_copy_link: 'Skopiuj link',
  com_ui_update_link: 'Zaktualizuj link',
  com_ui_create_link: 'Utwórz link',
  com_ui_share_link_to_chat: 'Udostępnij link w czacie',
  com_ui_share_error: 'Wystąpił błąd podczas udostępniania linku do czatu',
  com_ui_share_retrieve_error: 'Wystąpił błąd podczas usuwania udostępnionego linku.',
  com_ui_share_delete_error: 'Wystąpił błąd podczas usuwania udostępnionego linku.',
  com_ui_share_create_message:
    'Twoje imię i jakiekolwiek wiadomości dodane po udostępnieniu pozostaną prywatne.',
  com_ui_share_created_message:
    'Utworzono link udostępniony do Twojego czatu. Zarządzaj wcześniej udostępnionymi czatami w dowolnym momencie za pomocą Ustawień.',
  com_ui_share_update_message:
    'Twoje imię, niestandardowe instrukcje i jakiekolwiek wiadomości dodane po udostępnieniu pozostaną prywatne.',
  com_ui_share_updated_message:
    'Link udostępniony do Twojego czatu został zaktualizowany. Zarządzaj wcześniej udostępnionymi czatami w dowolnym momencie za pomocą Ustawień.',
  com_ui_shared_link_not_found: 'Nie znaleziono linku udostępnionego',
  com_ui_rename: 'Zmień nazwę',
  com_ui_archive: 'Archiwum',
  com_ui_archive_error: 'Nie udało się archiwizować rozmowy',
  com_ui_unarchive: 'Przywróć z archiwum',
  com_ui_unarchive_error: 'Nie udało się odtworzyć rozmowy z archiwum',
  com_ui_more_options: 'Więcej',
  com_ui_bookmarks: 'Zakładki',
  com_ui_bookmarks_rebuild: 'Przebuduj',
  com_ui_bookmarks_new: 'Nowa zakładka',
  com_ui_bookmark_delete_confirm: 'Czy na pewno chcesz usunąć tę zakładkę?',
  com_ui_bookmarks_title: 'Tytuł',
  com_ui_bookmarks_count: 'Licznik',
  com_ui_bookmarks_description: 'Opis',
  com_ui_bookmarks_create_success: 'Zakładka została pomyślnie utworzona',
  com_ui_bookmarks_update_success: 'Zakładka została pomyślnie zaktualizowana',
  com_ui_bookmarks_delete_success: 'Zakładka została pomyślnie usunięta',
  com_ui_bookmarks_create_error: 'Wystąpił błąd podczas tworzenia zakładki',
  com_ui_bookmarks_update_error: 'Wystąpił błąd podczas aktualizacji zakładki',
  com_ui_bookmarks_delete_error: 'Wystąpił błąd podczas usuwania zakładki',
  com_ui_bookmarks_add_to_conversation: 'Dodaj do bieżącej rozmowy',
  com_auth_error_login:
    'Nie udało się zalogować przy użyciu podanych danych. Sprawdź swoje dane logowania i spróbuj ponownie.',
  com_auth_no_account: 'Nie masz konta?',
  com_auth_sign_up: 'Zarejestruj się',
  com_auth_sign_in: 'Zaloguj się',
  com_auth_google_login: 'Zaloguj się przez Google',
  com_auth_facebook_login: 'Zaloguj się przez Facebooka',
  com_auth_github_login: 'Zaloguj się przez Githuba',
  com_auth_discord_login: 'Zaloguj się przez Discorda',
  com_auth_email: 'Email',
  com_auth_email_required: 'Wymagane jest podanie adresu email.',
  com_auth_email_min_length: 'Adres email musi mieć co najmniej 6 znaków.',
  com_auth_email_max_length: 'Adres email nie może być dłuższy niż 120 znaków.',
  com_auth_email_pattern: 'Wprowadź poprawny adres e-mail',
  com_auth_email_address: 'Adres e-mail',
  com_auth_password: 'Hasło',
  com_auth_password_required: 'Wymagane jest podanie hasła',
  com_auth_password_min_length: 'Hasło musi mieć co najmniej 8 znaków',
  com_auth_password_max_length: 'Hasło musi mieć mniej niż 128 znaków',
  com_auth_password_forgot: 'Zapomniałeś hasła?',
  com_auth_password_confirm: 'Potwierdź hasło',
  com_auth_password_not_match: 'Hasła nie są zgodne',
  com_auth_continue: 'Kontynuuj',
  com_auth_create_account: 'Utwórz konto',
  com_auth_error_create: 'Wystąpił błąd podczas tworzenia konta. Spróbuj ponownie.',
  com_auth_full_name: 'Pełne imię',
  com_auth_name_required: 'Imię jest wymagane',
  com_auth_name_min_length: 'Imię musi zawierać co najmniej 3 znaki',
  com_auth_name_max_length: 'Imię nie może zawierać więcej niż 80 znaków',
  com_auth_username: 'Nazwa użytkownika (opcjonalnie)',
  com_auth_username_required: 'Nazwa użytkownika jest wymagana',
  com_auth_username_min_length: 'Nazwa użytkownika musi zawierać co najmniej 2 znaki',
  com_auth_username_max_length: 'Nazwa użytkownika nie może zawierać więcej niż 20 znaków',
  com_auth_already_have_account: 'Masz już konto?',
  com_auth_login: 'Zaloguj się',
  com_auth_reset_password: 'Zresetuj hasło',
  com_auth_click: 'Kliknij',
  com_auth_here: 'TUTAJ',
  com_auth_to_reset_your_password: 'aby zresetować hasło.',
  com_auth_reset_password_link_sent: 'Link do resetowania hasła został wysłany',
  com_auth_reset_password_email_sent:
    'Na podany adres e-mail wysłano wiadomość z instrukcjami dotyczącymi resetowania hasła.',
  com_auth_error_reset_password:
    'Wystąpił problem z resetowaniem hasła. Nie znaleziono użytkownika o podanym adresie e-mail. Spróbuj ponownie.',
  com_auth_reset_password_success: 'Hasło zostało pomyślnie zresetowane',
  com_auth_login_with_new_password: 'Teraz możesz zalogować się, używając nowego hasła.',
  com_auth_error_invalid_reset_token: 'Ten token do resetowania hasła jest już nieważny.',
  com_auth_click_here: 'Kliknij tutaj',
  com_auth_to_try_again: 'aby spróbować ponownie.',
  com_auth_submit_registration: 'Zarejestruj się',
  com_auth_welcome_back: 'Witamy z powrotem',
  com_endpoint_open_menu: 'Otwórz menu',
  com_endpoint_bing_enable_sydney: 'Aktywuj Sydney',
  com_endpoint_bing_to_enable_sydney: 'Aby aktywować Sydney',
  com_endpoint_bing_jailbreak: 'Odblokuj',
  com_endpoint_bing_context_placeholder:
    'Bing może użyć do 7k tokenów dla \'kontekstu\', które mogą odnosić się do rozmowy.  Dokładny limit nie jest znany, ale przekroczenie 7 tysięcy tokenów może prowadzić do błędów.',
  com_endpoint_bing_system_message_placeholder:
    'OSTRZEŻENIE: Nadużywanie tej funkcji może skutkować ZAKAZEM korzystania z Bing! Kliknij na \'Wiadomość systemowa\' , aby uzyskać pełne instrukcje oraz domyślną wiadomość, jeśli zostanie pominięta, co jest predefiniowaną opcją \'Sydney\', uważaną za bezpieczną.',
  com_endpoint_system_message: 'Wiadomość systemowa',
  com_endpoint_default_blank: 'domyślnie: puste',
  com_endpoint_default_false: 'domyślnie: fałsz',
  com_endpoint_default_creative: 'domyślnie: kreatywny',
  com_endpoint_default_empty: 'domyślnie: puste',
  com_endpoint_default_with_num: 'domyślnie: {0}',
  com_endpoint_context: 'Kontekst',
  com_endpoint_tone_style: 'Styl tonu',
  com_endpoint_token_count: 'Liczba tokenów',
  com_endpoint_output: 'Wyjście',
  com_endpoint_google_temp:
    'Wyższe wartości oznaczają większą losowość, natomiast niższe wartości prowadzą do bardziej skoncentrowanych i deterministycznych wyników. Zalecamy dostosowanie tej wartości lub Top P, ale nie obu jednocześnie.',
  com_endpoint_google_topp:
    'Top-p wpływa na sposób, w jaki model wybiera tokeny do wygenerowania odpowiedzi. Tokeny są wybierane od najbardziej prawdopodobnych do najmniej, aż suma ich prawdopodobieństw osiągnie wartość top-p.',
  com_endpoint_google_topk:
    'Top-k wpływa na sposób, w jaki model wybiera tokeny do wygenerowania odpowiedzi. Top-k 1 oznacza, że wybrany token jest najbardziej prawdopodobny spośród wszystkich tokenów w słowniku modelu (nazywane też dekodowaniem zachłannym), podczas gdy top-k 3 oznacza, że następny token jest wybierany spośród 3 najbardziej prawdopodobnych tokenów (z uwzględnieniem temperatury).',
  com_endpoint_google_maxoutputtokens:
    'Maksymalna liczba tokenów, które mogą być wygenerowane w odpowiedzi. Wybierz niższą wartość dla krótszych odpowiedzi i wyższą wartość dla dłuższych odpowiedzi.',
  com_endpoint_google_custom_name_placeholder: 'Ustaw niestandardową nazwę dla Google',
  com_endpoint_google_prompt_prefix_placeholder:
    'Ustaw niestandardowe instrukcje lub kontekst. Jeśli puste, zostanie zignorowane.',
  com_endpoint_custom_name: 'Niestandardowa nazwa',
  com_endpoint_prompt_prefix: 'Prefiks promptu',
  com_endpoint_temperature: 'Temperatura',
  com_endpoint_default: 'domyślnie',
  com_endpoint_top_p: 'Top P',
  com_endpoint_top_k: 'Top K',
  com_endpoint_max_output_tokens: 'Maksymalna liczba tokenów wyjściowych',
  com_endpoint_openai_temp:
    'Wyższe wartości oznaczają większą losowość, natomiast niższe wartości prowadzą do bardziej skoncentrowanych i deterministycznych wyników. Zalecamy dostosowanie tej wartości lub Top P, ale nie obu jednocześnie.',
  com_endpoint_openai_max:
    'Maksymalna liczba tokenów do wygenerowania. Łączna długość tokenów wejściowych i wygenerowanych tokenów jest ograniczona długością kontekstu modelu.',
  com_endpoint_openai_topp:
    'Alternatywa dla próbkowania z temperaturą, nazywana próbkowaniem jądra, gdzie model rozważa wyniki tokenów z prawdopodobieństwem top_p. Przykładowo, 0,1 oznacza, że tylko tokeny składające się z 10% najwyższego prawdopodobieństwa są rozważane. Zalecamy dostosowanie tej wartości lub temperatury, ale nie obu jednocześnie.',
  com_endpoint_openai_freq:
    'Liczba pomiędzy -2,0 a 2,0. Dodatnie wartości karzą nowe tokeny w oparciu o ich dotychczasową częstotliwość występowania w tekście, co zmniejsza tendencję modelu do powtarzania tej samej linii dosłownie.',
  com_endpoint_openai_pres:
    'Liczba pomiędzy -2,0 a 2,0. Dodatnie wartości karzą nowe tokeny w oparciu o to, czy pojawiły się już w tekście, co zwiększa tendencję modelu do poruszania nowych tematów.',
  com_endpoint_openai_custom_name_placeholder: 'Ustaw własną nazwę dla ChatGPT',
  com_endpoint_openai_prompt_prefix_placeholder:
    'Ustaw własne instrukcje do umieszczenia w systemowej wiadomości. Domyślnie: brak',
  com_endpoint_anthropic_temp:
    'Zakres od 0 do 1. Użyj wartości bliżej 0 dla analizy/wyboru wielokrotnego, a bliżej 1 dla zadań twórczych i generatywnych. Zalecamy dostosowanie tej wartości lub Top P, ale nie obu jednocześnie.',
  com_endpoint_anthropic_topp:
    'Top-P wpływa na sposób wyboru tokenów przez model. Tokeny wybierane są od najbardziej prawdopodobnych do najmniej prawdopodobnych, aż suma ich prawdopodobieństw osiągnie wartość top-P.',
  com_endpoint_anthropic_topk:
    'Top-K wpływa na sposób wyboru tokenów przez model. Top-K równa 1 oznacza, że wybrany token jest najbardziej prawdopodobny spośród wszystkich tokenów w słowniku modelu (tzw. dekodowanie zachłanne), podczas gdy top-K równa 3 oznacza, że następny token zostaje wybrany spośród 3 najbardziej prawdopodobnych tokenów (za pomocą temperatury).',
  com_endpoint_anthropic_maxoutputtokens:
    'Maksymalna liczba tokenów, która może zostać wygenerowana w odpowiedzi. Wybierz mniejszą wartość dla krótszych odpowiedzi i większą wartość dla dłuższych odpowiedzi.',
  com_endpoint_frequency_penalty: 'Kara za częstotliwość',
  com_endpoint_presence_penalty: 'Kara za obecność',
  com_endpoint_plug_use_functions: 'Użyj funkcji',
  com_endpoint_plug_skip_completion: 'Pomiń uzupełnienie',
  com_endpoint_disabled_with_tools: 'wyłączony z narzędziami',
  com_endpoint_disabled_with_tools_placeholder: 'Wyłączony z wybranymi narzędziami',
  com_endpoint_plug_set_custom_instructions_for_gpt_placeholder:
    'Ustaw własne instrukcje do umieszczenia w systemowej wiadomości. Domyślnie: brak',
  com_endpoint_set_custom_name: 'Ustaw własną nazwę, w razie potrzeby odszukania tego ustawienia',
  com_endpoint_preset_name: 'Nazwa ustawienia',
  com_endpoint_new_topic: 'Nowy temat',
  com_endpoint: 'Punkt końcowy',
  com_endpoint_hide: 'Ukryj',
  com_endpoint_show: 'Pokaż',
  com_endpoint_examples: 'Przykłady',
  com_endpoint_completion: 'Uzupełnienie',
  com_endpoint_agent: 'Agent',
  com_endpoint_show_what_settings: 'Pokaż ustawienia {0}',
  com_endpoint_save: 'Zapisz',
  com_endpoint_export: 'Eksportuj',
  com_endpoint_save_as_preset: 'Zapisz jako predefiniowane ustawienie',
  com_endpoint_not_implemented: 'Nie zaimplementowano',
  com_endpoint_no_presets: 'Brak zapisanych predefiniowanych ustawień',
  com_endpoint_not_available: 'Punkt końcowy niedostępny',
  com_endpoint_clear_all: 'Usuń wszystko',
  com_endpoint_view_options: 'Pokaż opcje',
  com_endpoint_save_convo_as_preset: 'Zapisz konwersację jako predefiniowane ustawienie',
  com_endpoint_my_preset: 'Moje predefiniowane ustawienie',
  com_endpoint_agent_model: 'Model agenta (zalecany: GPT-3.5)',
  com_endpoint_completion_model: 'Model uzupełnienia (zalecany: GPT-4)',
  com_endpoint_func_hover: 'Aktywuj wtyczki jako funkcje OpenAI',
  com_endpoint_skip_hover:
    'Omijaj etap uzupełnienia sprawdzający ostateczną odpowiedź i generowane kroki',
  com_endpoint_config_token: 'Token konfiguracji',
  com_nav_plugin_store: 'Sklep z wtyczkami',
  com_nav_plugin_search: 'Wyszukiwanie wtyczek',
  com_nav_plugin_auth_error:
    'Wystąpił błąd podczas próby uwierzytelnienia tej wtyczki. Proszę spróbować ponownie.',
  com_nav_export_filename: 'Nazwa pliku',
  com_nav_export_filename_placeholder: 'Podaj nazwę pliku',
  com_nav_export_type: 'Typ',
  com_nav_export_include_endpoint_options: 'Dołącz opcje punktu końcowego',
  com_nav_enabled: 'Włączone',
  com_nav_not_supported: 'Nieobsługiwane',
  com_nav_export_all_message_branches: 'Eksportuj wszystkie gałęzie wiadomości',
  com_nav_export_recursive_or_sequential: 'Rekurencyjny czy sekwencyjny?',
  com_nav_export_recursive: 'Rekurencyjny',
  com_nav_export_conversation: 'Eksportuj konwersację',
  com_nav_shared_links: 'Linki udostępnione',
  com_nav_shared_links_manage: 'Beheren',
  com_nav_shared_links_empty: 'U hebt geen gedeeld links.',
  com_nav_shared_links_name: 'Naam',
  com_nav_shared_links_date_shared: 'Datum gedeeld',
  com_nav_theme: 'Motyw',
  com_nav_theme_system: 'Domyślny',
  com_nav_theme_dark: 'Ciemny',
  com_nav_theme_light: 'Jasny',
  com_nav_font_size: 'Rozmiar czcionki',
  com_nav_clear: 'Wyczyść',
  com_nav_clear_all_chats: 'Usuń wszystkie konwersacje',
  com_nav_confirm_clear: 'Potwierdź usunięcie',
  com_nav_close_sidebar: 'Zamknij pasek boczny',
  com_nav_open_sidebar: 'Otwórz pasek boczny',
  com_nav_send_message: 'Wyślij wiadomość',
  com_nav_log_out: 'Wyloguj',
  com_nav_user: 'Użytkownik',
  com_nav_archived_chats: 'Zarchiwizowane rozmowy',
  com_nav_archived_chats_manage: 'Zarządzaj',
  com_nav_archived_chats_empty: 'Nie masz żadnych zarchiwizowanych rozmów.',
  com_nav_archive_all_chats: 'Archiwizuj wszystkie rozmowy',
  com_nav_archive_all: 'Archiwizuj wszystkie',
  com_nav_archive_name: 'Nazwa',
  com_nav_archive_created_at: 'Utworzono',
  com_nav_clear_conversation: 'Wyczyść rozmowę',
  com_nav_clear_conversation_confirm_message:
    'Czy na pewno chcesz usunąć wszystkie konwersacje? Tej operacji nie można cofnąć.',
  com_nav_help_faq: 'Pomoc i często zadawane pytania',
  com_nav_settings: 'Ustawienia',
  com_nav_search_placeholder: 'Szukaj wiadomości',
  com_nav_info_bookmarks_rebuild:
    'Jeśli liczba zakładek jest nieprawidłowa, przebuduj informacje o zakładkach. Liczba zakładek zostanie ponownie obliczona, a dane przywrócone do prawidłowego stanu.',
  com_nav_setting_general: 'Ogólne',
  com_ui_import_conversation: 'Importuj',
  com_ui_import_conversation_info: 'Importuj konwersacje z pliku JSON',
  com_ui_import_conversation_success: 'Konwersacje zostały pomyślnie zaimportowane',
  com_ui_import_conversation_error: 'Wystąpił błąd podczas importowania konwersacji',
  com_ui_accept: 'Akceptuję',
  com_ui_decline: 'Nie akceptuję',
  com_ui_terms_and_conditions: 'Warunki użytkowania',
  com_ui_no_terms_content: 'Brak treści warunków użytkowania do wyświetlenia',
  com_nav_lang_english: 'English',
  com_nav_lang_chinese: '中文',
  com_nav_lang_german: 'Deutsch',
  com_nav_lang_spanish: 'Español',
  com_nav_lang_french: 'Français ',
  com_nav_lang_italian: 'Italiano',
  com_nav_lang_polish: 'Polski',
  com_nav_lang_brazilian_portuguese: 'Português Brasileiro',
  com_nav_lang_russian: 'Русский',
  com_nav_lang_japanese: '日本語',
  com_nav_lang_swedish: 'Svenska',
  com_nav_lang_korean: '한국어',
  com_nav_lang_vietnamese: 'Tiếng Việt',
  com_nav_lang_traditionalchinese: '繁體中文',
  com_nav_lang_arabic: 'العربية',
  com_nav_lang_turkish: 'Türkçe',
  com_nav_lang_dutch: 'Nederlands',
  com_nav_lang_indonesia: 'Indonesia',
  com_nav_lang_hebrew: 'עברית',
  com_nav_lang_finnish: 'Suomi',
};
